import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import GoogleAnalytics from '../../../util/Ga.js';

// ES6 class-style
class SpotlightBanner extends PreLoginSessionCheck {
  constructor(props){
    super(props);
  }

  rendermsg(){
   if(this.props.msg || ""){
    return(
      <div className="msg">
  {this.props.msg}
</div>
    )
   }
  }


  render() {
  	return(
<section className="bg-yel-large">
<div className="container mask"><h1>{this.props.title}</h1></div>
{this.rendermsg()}
</section>
  	);
  }
}

export default SpotlightBanner; 


// WEBPACK FOOTER //
// ./src/prelogin/src/components/SpotlightBanner.js